import styled from 'styled-components';

export const ToastContainer = styled.div`
	position: absolute;
	width: 100%;
	padding: 1rem;
	top: 3.5rem;
	transition: top 0.3s ease-in-out;
	z-index: 11;
	&.hidden {
		top: -10rem;
	}
`;

interface ToastProps {
	margin?: string;
}

export const Toast = styled.div`
	background: rgb(37, 114, 38);
	border-radius: 10px;
	box-shadow: var(--generic-box-shadow);
	padding: 0.5rem;
	margin: ${(props: ToastProps) => (props.margin ? props.margin : '')};
	border: 2px solid var(--ion-color-secondary-tint);
`;

export const ToastInnerContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
`;

export const ToastHeader = styled.p`
	font-size: 0.75rem;
	//text-transform: uppercase;
	color: var(--ion-color-light-shade);
	margin: 0;
`;

export const ToastTitle = styled.h3`
	font-size: 1.125rem;
	margin: 0 0 5px;
`;

export const ToastImg = styled.div`
	min-width: 6rem;
	max-width: 6rem;
	height: 6rem;
	display: block;
	aspect-ratio: 1/1;
	border-radius: 10px;
	object-fit: cover;
	object-position: center center;
	overflow: hidden;
	position: relative;
	/* box-shadow: var(--generic-box-shadow); */
`;

export const ToastTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-top: 2px;

	&.offline {
		padding: 0.5rem;
	}
`;

export const ToastCaption = styled.p`
	margin: 0;
	font-size: 0.875rem;
	/* height: 2.2rem; */
	line-height: 1.3;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`;
